import Model from './Model'
import Role from './Role'
import axios from 'axios'
import { camelCase } from 'lodash'
import { featureFlags } from 'Utils/constants'
import GlobalPolicyService from 'Services/GlobalPolicyService'

const agencyFeatureFlags = Object.values(featureFlags.agency)

class Agency extends Model {
  constructor (initialData) {
    super(initialData, {
      momentKeys: [],
    })

    agencyFeatureFlags.forEach(flag => {
      // Changes `feature_flag` to `hasFeatureFlag`
      const fnName = camelCase(`has_${flag}`)

      const fn = function () {
        return this.isFeatureEnabled(flag)
      }

      // Define a getter of `fnName` that runs function `fn`
      Object.defineProperty(this, fnName, { get: fn })
    })

    this.policy = GlobalPolicyService.findOrCreate('Agency', this)
  }

  isFeatureEnabled (featureName) {
    return !!this.enabled_features.includes(featureName)
  }

  getResources () {
    return axios.get(`/api/v1/agencies/${this.id}/resources`)
      .then(response => {
        this.resources = response.data
        if (this.resources && this.resources.roles) {
          this.resources.roles = this.resources.roles.map(r => new Role(r))
        }
        return response.data
      })
      .catch(console.error)
  }

  // NEW PERMISSION STYLE BEGIN

  get canViewAgencyOfficerTypes () {
    return this.policy.canViewAgencyOfficerTypes
  }

  // NEW PERMISSION STYLE END
}

export default Agency
